// |-- Built-in Dependencies --|
import React, { useState, useEffect } from "react";

// |-- External Dependencies --|
import { Form, Formik } from "formik";
import { object, string } from "yup";
import { useSelector } from "react-redux";

import Dialog from "@mui/material/Dialog";
import CircularProgress from "@mui/material/CircularProgress";

// |-- Internal Dependencies --|
import { RootState } from "src/redux/store";
import { showToast } from "src/utils/showToaster";
import DispositionLevelTwoForm from "../Layout/DispositionLevelTwoForm";
import {
  useGetDispositionLevelTwoByIdQuery,
  useEditDispositionLevelTwoMutation,
} from "src/services/DispositionLevelTwoServices";

// |-- Types --|
type Props = {
  dispositionLevelSecondId: string;
  onClose: () => void;
};

export type FormInitialValues = {
  dispositionLevelSecondName: string;
};

const EditDispositionLevelTwoFormWrapper = ({
  dispositionLevelSecondId,
  onClose,
}: Props) => {
  const [dispositionLevelSecondData, setDispositionLevelSecondData] =
    useState<any>([]);

  const { filterValue: dispositionLevelFirstId }: any = useSelector(
    (state: RootState) => state.dispositionLevelTwo
  );

  const { data, isLoading, isFetching } = useGetDispositionLevelTwoByIdQuery(
    dispositionLevelSecondId,
    {
      skip: !dispositionLevelSecondId,
    }
  );
  const [editDispositionLevelOne] = useEditDispositionLevelTwoMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setDispositionLevelSecondData(data?.data[0]);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: FormInitialValues = {
    dispositionLevelSecondName:
      dispositionLevelSecondData?.dispositionSecondName,
  };

  const validationSchema = object({
    dispositionLevelSecondName: string().required(
      "Disposition level second name is required"
    ),
  });

  const onSubmitHandler = (values: FormInitialValues) => {
    const formatedValues = {
      dispositionFirstId: dispositionLevelFirstId,
      dispositionSecondName: values.dispositionLevelSecondName,
    };
    setTimeout(() => {
      editDispositionLevelOne({
        id: dispositionLevelSecondId,
        body: formatedValues,
      })
        .then((res: any) => {
          if (res?.data?.status) {
            showToast("success", "added successfully!");
            onClose();
          } else {
            showToast("error", res?.data?.message);
            onClose();
          }
        })
        .catch((err) => {
          console.error("error", err);
        });
    }, 1000);
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmitHandler}
      >
        {(formikProps) => {
          return (
            <Form>
              {(isLoading || isFetching) && (
                <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                  <CircularProgress />
                </div>
              )}
              <DispositionLevelTwoForm
                formType="Edit"
                onClose={onClose}
                formikProps={formikProps}
              />
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default EditDispositionLevelTwoFormWrapper;
